<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <div class="d-flex flex-row align-items-center justify-content-between w-100">
        <div class="cdc-label m-0">
          {{appSelected !== undefined ? App[appSelected] : ('Empty' | translate)}}
          <ng-container *ngIf="tagSelected?.length">
            -
            <span *ngFor="let tagId of tagSelected; let last = last">
              {{ availableTags[tagId] }}<span *ngIf="!last">, </span>
            </span>
          </ng-container>
        </div>
        <mat-icon *ngIf="
        !(component.type == ComponentType.URL && appSelected == App.CONTENT)
        && !(component.type == ComponentType.INTITULE && appSelected == App.CONTENT)
        && !(component.type == ComponentType.ADDRESS && appSelected == App.CONTENT)
        && !(component.type == ComponentType.VISUAL_PUBLICATION && appSelected == App.CONTENT)
        && !(component.type == ComponentType.ACTIVITY_PRESTATIONS && appSelected == App.CONTENT)"
        class="cdc-label-icon" matTooltip="{{ 'Delete' | translate }}" (click)="onRemoveConnection($event)">delete</mat-icon>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="d-flex flex-row justify-content-center gap-1">
    <div class="cdc-form-field col-12 col-lg-12 col-md-12" [ngClass]="{
      'error': appSelected === undefined,
      'actif': appSelected !== undefined
        && !(component.type == ComponentType.URL && appSelected == App.CONTENT)
        && !(component.type == ComponentType.INTITULE && appSelected == App.CONTENT)
        && !(component.type == ComponentType.ADDRESS && appSelected == App.CONTENT)
        && !(component.type == ComponentType.VISUAL_PUBLICATION && appSelected == App.CONTENT)
        && !(component.type == ComponentType.ACTIVITY_PRESTATIONS && appSelected == App.CONTENT)
    }">
      <div class="cdc-label">{{ 'App' | translate }}</div>
      <select [(ngModel)]="appSelected" (ngModelChange)="onAppChange($event)" inactif matNativeControl
      [disabled]="(component.type == ComponentType.URL && appSelected == App.CONTENT)
        || (component.type == ComponentType.INTITULE && appSelected == App.CONTENT)
        || (component.type == ComponentType.ADDRESS && appSelected == App.CONTENT)
        || (component.type == ComponentType.VISUAL_PUBLICATION && appSelected == App.CONTENT)
        || (component.type == ComponentType.ACTIVITY_PRESTATIONS && appSelected == App.CONTENT)">
        <option *ngFor="let app of availableApps | keyvalue" [value]="app.key">{{ app.value }}</option>
      </select>
      <mat-error *ngIf="appSelected === undefined">{{ 'App is required' | translate }}</mat-error>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-center gap-1" *ngIf="appSelected != undefined">
    <div class="cdc-form-field"
      [ngClass]="{
        'actif': ((appSelected !== App.CDC && tagSelected) || (appSelected === App.CDC && component.tag)) && component.type != ComponentType.ACTIVITY_PRESTATIONS,
        'error': (appSelected !== App.CDC && !tagSelected) || (appSelected === App.CDC && !component.tag),
        'col-6 col-lg-6 col-md-6': needSubType,
        'col-12 col-lg-12 col-md-12': !needSubType }">
      <div class="cdc-label">{{ 'Tag' | translate }}</div>

      <select *ngIf="appSelected !== App.CDC && component.type != ComponentType.ACTIVITY_PRESTATIONS"
      [(ngModel)]="tagSelected"
      (ngModelChange)="onTagChange()" inactif matNativeControl
      [disabled]="Object.keys(availableTags).length <= 1">
        <option *ngFor="let tag of availableTags | keyvalue" [value]="tag.key">{{ tag.value }}</option>
      </select>

      <mat-form-field class="mt-1 d-flex flex-column select-container component-types" *ngIf="component.type == ComponentType.ACTIVITY_PRESTATIONS && appSelected == App.CONTENT">
        <mat-select [(value)]="tagSelected" multiple (selectionChange)="onTagChange()" [disabled]="true">
          <mat-option *ngFor="let tag of availableTags | keyvalue" [value]="tag.key">{{ tag.value | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <input *ngIf="appSelected === App.CDC" matInput type="text" placeholder="{{'Tag' | translate}}" [value]="component.tag" [disabled]="true">

      <mat-error *ngIf="(appSelected !== App.CDC && !tagSelected) || (appSelected === App.CDC && !component.tag)">{{ 'Tag is required' | translate }}</mat-error>
    </div>

    <div *ngIf="needSubType"
      class="cdc-form-field col-6 col-lg-6 col-md-6"
      [ngClass]="{'error': component.config?.contentAPISubType == undefined}">
      <div class="cdc-label">{{ 'Type' | translate }}</div>
      <input matInput type="text" [value]="(component.config?.contentAPISubType ?? '' | translate)" [disabled]="true">

      <mat-error *ngIf="component.config?.contentAPISubType == undefined">{{ 'Type is required' | translate }}</mat-error>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-center gap-1 mt-2" *ngIf="this.appSelected !== App.CDC && appSelected != undefined">
    <div class="cdc-form-field col-6 col-lg-6 col-md-6" [ngClass]="{
      'error': connection.trigger === undefined,
      'actif': connection.trigger !== undefined && appSelected == App.CONTENT
    }">
      <div class="cdc-label">{{ 'Direction' | translate }}</div>
      <select [(ngModel)]="connection.direction" (ngModelChange)="onDirectionChange($event)" inactif matNativeControl
      [disabled]="appSelected != App.CONTENT">
        <option *ngFor="let direction of availableDirections" [value]="direction.value">{{ direction.key }}</option>
      </select>
      <mat-error *ngIf="connection.direction === undefined">{{ 'Direction is required' | translate }}</mat-error>
    </div>

    <div class="cdc-form-field col-6 col-lg-6 col-md-6" [ngClass]="{
      'error': connection.trigger === undefined,
      'actif': connection.trigger !== undefined && appSelected != App.CUSTOMER_PROFILE && appSelected != App.ICARD
    }">
      <div class="cdc-label">{{ 'Trigger' | translate }}</div>
      <select [(ngModel)]="connection.trigger" (ngModelChange)="onTriggerChange($event)" inactif matNativeControl
      [disabled]="appSelected == App.CUSTOMER_PROFILE || appSelected == App.ICARD">
        <option *ngFor="let trigger of availableTriggers" [value]="trigger.value">{{ trigger.key }}</option>
      </select>
      <mat-error *ngIf="connection.trigger === undefined">{{ 'Trigger is required' | translate }}</mat-error>
    </div>
  </div>

</mat-expansion-panel>
